import { inject, Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { catchError, Observable, throwError, tap } from 'rxjs';
import { User } from './user.interface';
import { environment } from '../../../../environments/environment';
import { TokenService } from './token.service';

@Injectable({ providedIn: 'root' })
export class UserService {
  private apiGatewayUrl = environment.apiGatewayUrl;
  private http = inject(HttpClient);
  private tokenService = inject(TokenService);

  getUserDetails(userId: string): Observable<User> {

    return this.http
      .get<User>(`${this.apiGatewayUrl}/user/${userId}`)
      .pipe(
        tap((user) => {
          this.storeUserDetails(user);
        }),
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    console.error('An error occurred:', error);
    return throwError(() => error);
  }

  private storeUserDetails(user: User): void {
    localStorage.setItem('user', JSON.stringify(user));
  }
}
